import { dataMember, required } from 'santee-dcts';
import { IFilterSelectItem } from './../../shared/sample-tracking-select/sample-tracking-select.component';

export enum FilterTypeEnum {
    protocol = 1,
    project = 2,
    investigatorSite = 3,
    visitCode = 4,
    country = 5,
    region = 6,
}

export class ProtocolGridData {
    @dataMember()
    @required({ nullable: true })
    public protocolCode: string;

    @dataMember()
    @required({ nullable: true })
    public projectNumber: string;

    @dataMember()
    @required({ nullable: true })
    public accessionnumber: string;

    @dataMember()
    @required({ nullable: true })
    public investigatorNumber: string;

    @dataMember()
    @required({ nullable: true })
    public investigatorName: string;

    @dataMember()
    @required({ nullable: true })
    public protocolVisitCode: string;

    @dataMember()
    @required({ nullable: true })
    public protocolVisitDescription: string;

    public isSavable = true;

    public isRead = false;
}


export class ProtocolFilterData {
    @dataMember()
    @required()
    public protocolCode: string;

    @dataMember()
    @required()
    public protocolId: number;

    @dataMember()
    @required()
    public projectNumber: string;

    @dataMember()
    @required()
    public subprotocolId: number;

    @dataMember()
    @required()
    public investigatorSiteId: number;

    @dataMember()
    @required()
    public investigatorNumber: string;

    @dataMember()
    @required()
    public investigatorName: string;

    @dataMember()
    @required()
    public countryId: number;

    @dataMember()
    @required()
    public countryName: string;

    @dataMember()
    @required({ nullable: true })
    public protocolVisitCode: number;

    @dataMember()
    @required({ nullable: true })
    public protocolVisitDescription: string;

    @dataMember()
    public sponsorName: string;

    @dataMember()
    public region: string;
}

export class SampleCountData {
    @dataMember()
    @required()
    public samplesNotReceived: number;

    @dataMember()
    @required()
    public samplesReceived: number;

    @dataMember()
    @required()
    public samplesInInventory: number;

    @dataMember()
    @required()
    public samplesShipped: number;

    @dataMember()
    @required()
    public samplesDiscarded: number;

    @dataMember()
    @required()
    public samplesRemoved: number;

    @dataMember()
    @required()
    public samplesOnHold: number;

    @dataMember()
    @required()
    public samplesCollected: number;

    @dataMember()
    @required()
    public samplesCancelled: number;

    @dataMember()
    @required()
    public samplesShippedFromSiteToLabcorp: number;

    @dataMember()
    @required()
    public samplesShippedFromSiteToThirdParty: number;
}

export class PortfolioFilterRequestData {

    public sponsorName: string;

    public protocolCode: string;
}

export class SampleTrackingSampleCountRequest {
    public filterType: number;
    public filterId: number[];
    public investigatorSiteId?: number[];
    public sponsorProtocolIds?: ProtocolSponsorPairs[];
}

export class SelectedFilter {
    public label?: string;
    public dbColumn?: string;
    public selectedValues?: string[];
    public selectedIds?: number[];
    public secondaryIds?: string[];
    public filterItems?: IFilterSelectItem[];
    public setFilter?: boolean;
    public filterType?: FilterTypeEnum;
    public invNumbers?: IFilterSelectItem[];
}

export class FilterList {
    public protocol?: IFilterSelectItem[];
    public project?: IFilterSelectItem[];
    public country?: IFilterSelectItem[];
    public investigatorSite?: IFilterSelectItem[];
    public allCountires?: IFilterSelectItem[];
    public allInvSites?: IFilterSelectItem[];
    public resetFilter?: boolean;
}

export enum FilterNames {
    protocol = 'Protocol',
    project = 'Project №',
    country = 'Country',
    investigatorNum = 'Investigator Name/ Number',
    visitCode = 'Visit Description/ Protocol Visit Code',
    samples = 'Samples',
    region = 'Region'
}

export enum DbFilterNames {
    protocol = 'protocolid',
    project = 'subprotocolid',
    country = 'countryid',
    investigatorNum = 'investigatorsiteid',
    region = 'subprotocol_region'
}


export interface ProtocolSponsorPairs {
    protocolId: number;
    protocolCode: string;
    sponsorName: string;
}